import React from 'react';
import {
    TextField,
    Box,
    Grid,
    Typography,
     // 
     Divider,Paper,
} from '@mui/material';

const boxContent = {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
}
const typographyText = {
    textAlign:'left',
    width:'15%'
}
const AllotmentItem = (props) => {
    return (
        <Grid item align="center" xs={12} sx={{ pl: 2, pr: 2 }}>
            <Box style={boxContent}>
                <Typography style={typographyText} variant='subtitle2'> {props.displayName ? props.displayName : ''} </Typography>
                <Box sx={{width:'100px'}}> 
                    <TextField                    
                        label={props.displayName ? props.displayName : ''}
                        size="small"
                        id="outlined-required"
                        type="number"
                        value={props.value}
                        onChange={(e) => {
                            props.onChange(e)
                        }}
                    />
                </Box> 
            </Box>
            <Divider sx={{ my: 2 }} orientation="horizontal" />
        </Grid>
    )
}

export default AllotmentItem;